import type { RouteRecordRaw } from 'vue-router'

export const publicRoutes: Array<RouteRecordRaw> = [
  // Public
  {
    path: '/',
    name: 'Home',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/signup',
    name: 'SignUp',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/SignUpView.vue'),
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/views/ResetPasswordView.vue'),
  },
]
